<template>
	<div>
		<egranty-section-divider
			:small="true"
			text="Angielska nazwa projektu"
		></egranty-section-divider>

		<v-card-text>
			<display-text-component
				label="Nazwa"
				:value="value"
				flex="full-width"/>
		</v-card-text>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";

	export default {
		name: "AgencyEnglishTitleReadOnlyView",
		components: {DisplayTextComponent, EgrantySectionDivider},

		props: {
			value: String
		}
	};
</script>

<style scoped>

</style>